import styled from "styled-components";
import { FlexipageColors, headingSizes } from "../../Flexipage/Global/FlexipageStyles";
import { colors } from "../../../utils/styles";

export const CaseStudyWrapper = styled.article`

	--_grid-text-col: minmax(345px, 1fr);
	--_grid-col-gap: 2.5rem;
	--_figure-offset: -120px;

	.container {
		display: flex;
		flex-direction: column;
		gap: 2.5rem;
		font-family: Poppins, sans-serif;
	}

	.logos {
		display: flex;
		align-items: center;
		gap: 3.5rem;

		img {
			display: block;
			max-height: 45px;
			max-width: 120px;
			object-fit: contain;
		}
	}

	.grid {
		display: grid;
		grid-template-columns: var(--_grid-text-col) auto;
		grid-template-rows: auto auto 1fr;
		gap: 2rem var(--_grid-col-gap);

		> h3 {
			grid-column: 1;
			grid-row: 1;

			margin: 0;

			color: #144056;
			font-size: ${headingSizes.h4.desktop[0]};
			line-height: ${headingSizes.h4.desktop[1]};
			font-family: ${headingSizes.h4.fontFamily};
			font-weight: ${headingSizes.h4.fontWeight};

			@media (max-width: ${FlexipageColors.breakpointTablet}) {
				font-size: ${headingSizes.h4.tablet[0]};
				line-height: ${headingSizes.h4.tablet[1]};
			}

			@media (max-width: ${FlexipageColors.breakpointMobile}) {
				font-size: ${headingSizes.h4.mobile[0]};
				line-height: ${headingSizes.h4.mobile[1]};
			}
		}

		> .image {
			grid-column: 2;
			grid-row: 1 / 4;

			width: 100%;
			min-width: calc((var(--_figure-offset) * -1) - var(--_grid-col-gap));
			max-width: 478px;
			max-height: 450px;
			border-radius: 1rem;
			overflow: hidden;

			margin-bottom: 1rem;

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}

		> figure {
			grid-column: 1;
			grid-row: 2;
			align-self: start;

			display: flex;
			flex-direction: column;
			gap: 1rem;
			margin: 0;
			margin-right: var(--_figure-offset);

			background-color: ${colors.primaryBlue};
			color: white;
			border-radius: 1rem;
			padding: 2rem;

			font-size: 1rem;
			line-height: 1.6;

			blockquote {
				margin: 0;

				p {
					color: inherit;

					&:last-child {
						margin-bottom: 0;
					}
				}
			}

			cite {
				font-style: normal;
				font-weight: 600;
			}
		}

		> .stats {
			grid-column: 1;

			display: flex;
			justify-content: space-between;
			gap: 2rem;
			margin: 0;
			padding: 0;

			li {
				display: flex;
				justify-content: center;

				list-style: none;
				margin: 0;
				padding: 0;

				.stat {
					display: block;
				}

				strong {
					display: block;
					font-size: 2rem;
					line-height: 1.2;
					font-weight: 600;
					color: ${colors.primaryBlue};
					margin-bottom: 0.5rem;
				}

				.label {
					display: block;
				}
			}

			.separator {
				flex-shrink: 0;
				flex-basis: 0;
				border-left: 1px ${colors.secondaryBlue2} solid;
			}
		}
	}

	&:where(.alt) {
		.grid {
			grid-template-columns: auto var(--_grid-text-col);

			> h3 {
				grid-column: 2;
			}

			> .image {
				grid-column: 1;
			}

			> figure {
				grid-column: 2;
				margin-right: 0;
				margin-left: var(--_figure-offset);
				background-color: ${colors.secondaryBlue};
			}

			> .stats {
				grid-column: 2;
			}
		}
	}

	&:has(.stats li:nth-child(5)) {
		@media screen and (max-width: 1200px) {
			.grid {
				> .image {
					grid-row: 1 / 3;
				}

				> .stats {
					grid-column: 1 / -1;
				}
			}
		}
	}

	@media screen and (max-width: ${FlexipageColors.breakpointTablet}) {
		.grid {
			> .image {
				grid-row: 1 / 3;
			}

			> .stats {
				grid-column: 1 / -1;
			}
		}
	}

	@media screen and (max-width: ${FlexipageColors.breakpointMobile}) {
		.grid {
			display: flex;
			flex-direction: column;
			gap: 0;

			h3 {
				margin-bottom: 1.5rem;
			}

			> .image {
				max-width: none;
				border-bottom-left-radius: 0;
				border-bottom-right-radius: 0;
				margin-bottom: 0;

				img {
					aspect-ratio: 54 / 36;
				}
			}

			> figure {
				border-top-left-radius: 0;
				border-top-right-radius: 0;
				margin-inline: 0;
			}

			> .stats {
				margin-top: 2rem;
				gap: 1rem;

				.label {
					font-size: 0.875rem;
					line-height: 1.4;
				}
			}
		}
	}

	@media screen and (max-width: 374px) {
		.grid {
			> .stats {
				flex-direction: column;

				li {
					justify-content: start;
				}

				.separator {
					border: 0 none;
					border-top: 1px ${colors.secondaryBlue2} solid;
					max-width: 60px;
				}
			}
		}
	}
`